// #ux-redesign-start: reset de scroll al cambiar de ruta (sidebar click, etc.)
// Antes solo reseteaba `mainPanel.current.scroll(...)`. Pero el contenedor real
// del scroll cambia según plataforma:
//   - macOS / Linux: scroll global del <html>/<body>.
//   - Windows: PerfectScrollbar inicializado sobre `#full-page` (ver Admin.jsx).
// Ahora reseteamos los tres posibles contenedores para garantizar que cualquier
// navegación deje al usuario arriba.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop(props) {
  const { pathname, search } = useLocation();
  const { mainPanel } = props;

  useEffect(() => {
    // a) ventana global
    if (typeof window !== "undefined" && window.scrollTo) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
    // b) main panel (admin layout)
    if (mainPanel && mainPanel.current && typeof mainPanel.current.scroll === "function") {
      mainPanel.current.scroll({ top: 0, behavior: "auto" });
    }
    // c) #full-page (PerfectScrollbar host en Windows)
    if (typeof document !== "undefined") {
      const fullPage = document.getElementById("full-page");
      if (fullPage && typeof fullPage.scroll === "function") {
        fullPage.scroll({ top: 0, behavior: "auto" });
      }
    }
  }, [pathname, search, mainPanel]);

  return null;
}
// #ux-redesign-end
